import React from 'react';
import PropTypes from 'prop-types';

//TODO: rename to Switcher

class FilterSwitcher extends React.Component {

    shouldComponentUpdate(nextProps) {
        let curProps = this.props;

        if (curProps.value !== nextProps.value) {
            return true;
        }

        if (curProps.className !== nextProps.className) {
            return true;
        }

        return false;
    }

    render() {
        var wrapperClasses = 'filter-switcher';
        let {
            labelIfTrue,
            labelIfFalse,
            onClick,
            value,
            minWidth,
            maxWidth,
            offMode,
            filterMode,
            withBorder,
            labelOnLeftSide,
            children,
            className,
            hoveredMode
        } = this.props;

        let style = {};

        if (minWidth) {
            style.minWidth = minWidth;
        }

        if (maxWidth) {
            style.maxWidth = maxWidth;
        }

        return <div className={`${wrapperClasses} ${value && 'checked'} ${offMode && 'off-mode'} ${withBorder && 'with-border'} ${labelOnLeftSide && 'label-on-left-side'} ${filterMode && 'filter-mode'} ${className}`}
            style={style}
            onClick={onClick}>
            <span className={`filter-switcher_label ${hoveredMode && 'hovered-mode'}`}>
                {children}
                {!children ? (value ? labelIfTrue : labelIfFalse) : ''}
            </span>
        </div>;
    }
}

FilterSwitcher.propTypes = {
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    labelIfTrue: PropTypes.string,
    labelIfFalse: PropTypes.string,
    minWidth: PropTypes.string,
    offMode: PropTypes.bool,
    withBorder: PropTypes.bool,
};

export default FilterSwitcher;